import { useMemo } from "react";
import { useSelector } from "react-redux";

import { Areas } from "components/Layout/types";
import { getAppConfigModules } from "ducks/appConfig";
import { ROUTES } from "appConfig/routes";
import { MODULES_AREA } from "../../appConfig/modulesArea";
import { MODULES_PRIORITY } from "../../appConfig/modulesPriority";
import { SUB_MODULES } from "../../appConfig/subModules";
import { ClientModule } from "../../appConfig/types";

type SortedModules = Partial<Record<Areas, ClientModule[]>>;

export const useModules = (): SortedModules => {
  const modules = useSelector(getAppConfigModules);

  return useMemo(
    () =>
      modules
        .sort((a, b) => MODULES_PRIORITY[a.name] - MODULES_PRIORITY[b.name])
        .reduce((acc, cur) => {
          const { name } = cur;
          const module: ClientModule = { route: ROUTES[name], ...cur };
          const area = MODULES_AREA[name];

          if (SUB_MODULES[name]) {
            module.submodules = SUB_MODULES[name];
          }

          acc[area] = acc[area] ? acc[area].concat(module) : [module];

          return acc;
        }, {}),
    [modules],
  );
};
